import { render, staticRenderFns } from "./RichInputLink.vue?vue&type=template&id=d89a6644&"
import script from "./RichInputLink.vue?vue&type=script&lang=js&"
export * from "./RichInputLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports